exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-form-check-label{color:var(--ds-color-london-5);cursor:pointer;font-family:var(--ds-type-system-sans-lining);font-size:var(--ds-type-scale-0);line-height:var(--ds-type-leading-lower)}.ds-form-check-label.ds-form-check-label--disabled{color:hsla(var(--ds-color-hsl-london-5),.5)}", ""]);

// exports
exports.locals = {
	"ds-form-check-label": "ds-form-check-label",
	"ds-form-check-label--disabled": "ds-form-check-label--disabled"
};